
                import "css-modules://src_components_navigation_navigationgrid"
                export default {"Main":"_bae6b7","Centered":"_078758","Inner":"_e02661","Logo":"_27f65b","MenuButton":"_6d08fc","LangButton":"_4cc74f","Loading":"_612dfc","Date":"_9600d6","Visible":"_073282"}
            